// Function to update the filter count
function updateFilterCount() {
  const activeFilters = document.querySelectorAll('.active-facets__button');
  const filterCount = activeFilters.length;
  const filterCountElements = document.querySelectorAll('.selected-filters-count');

  filterCountElements.forEach(element => {
    element.textContent = filterCount > 0 ? ` (${filterCount})` : '';
  });
}

// Function to observe changes in the active filters
function observeActiveFilters() {
  const targetNode = document.querySelector('.active-facets');

  if (targetNode) {
    const config = {
      childList: true,
      subtree: true
    };

    const callback = function (mutationsList, observer) {
      for (let mutation of mutationsList) {
        if (mutation.type === 'childList') {
          updateFilterCount();
        }
      }
    };

    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  }
}

// Function to update filter count on mobile facet changes
function handleMobileFacetChanges() {
  const mobileDetails = document.querySelectorAll('.mobile-facets__details');

  mobileDetails.forEach(detail => {
    detail.addEventListener('change', function (event) {
      // Wait for Shopify to update the active facets
      setTimeout(updateFilterCount, 100);
    });
  });
}

// Initial count update, start observing, and handle mobile facets
document.addEventListener('DOMContentLoaded', function () {
  updateFilterCount();
  observeActiveFilters();
  handleMobileFacetChanges();
});